export default "__VITE_ASSET__lsv7AfLm__"